import Marquee from "react-fast-marquee";

const ITEMS = ["Stop in, taste life", "Trends, fun, and treats", "Candy & toys from Canada", "New drops weekly"];

export default function MarqueeStrip() {
  return (
    <div data-testid="editorial-marquee" className="border-b-2 border-[#0A0A0A] bg-[#FF2A54] py-4">
      <Marquee speed={40} gradient={false} aria-hidden="true">
        {ITEMS.map((item) => (
          <span key={item} className="mx-8 flex items-center gap-8 font-display text-xl font-black uppercase tracking-tight text-[#FFD700] sm:text-2xl">
            {item} <span className="text-white">&#10022;</span>
          </span>
        ))}
      </Marquee>
    </div>
  );
}
